<template>
  <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12">
    <path
      d="M.5 8H10a1.5 1.5 0 0 0 1.5-1.5V1M.5 8 4 4.5M.5 8 4 11.5"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
